import {AbstractModel} from '../../abstract-model';
import {FunnelLinkCondition} from './funnel-link-condition';

export class FunnelLink extends AbstractModel {
  id: number | null = null;
  fromId: number | null = null;
  toId: number | null = null;
  conditions: FunnelLinkCondition[] = [];
}
